const DOT_DELAYS_MS = [0, 150, 300]

export const staffTypingLabel = (staffName: string | null) =>
  staffName ? `${staffName} is typing` : 'Support is typing'

export const StaffTypingIndicator = ({
  staffName,
}: {
  staffName: string | null
}) => (
  <div className="flex min-w-0 items-center gap-2 text-xs text-ink-subtle">
    <span className="truncate">{staffTypingLabel(staffName)}</span>
    <span className="flex items-end gap-0.5">
      {DOT_DELAYS_MS.map((delayMs) => (
        <span
          key={delayMs}
          style={{ animationDelay: `${delayMs}ms` }}
          className="h-1 w-1 animate-bounce rounded-full bg-blue-4"
        />
      ))}
    </span>
  </div>
)
